/* global axios */
import ApiClient from '../ApiClient';

class ZaloOaChannel extends ApiClient {
  constructor() {
    super('callbacks', { accountScoped: true });
  }

  authorizeUrl(inboxName) {
    return axios.post(`${this.url}/zalo_oa_authorize_url`, {
      inbox_name: inboxName,
    });
  }
}

export default new ZaloOaChannel();
